import { useState, useEffect, useRef, useContext } from 'react';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { IconButton, InputScore, Switch } from '@teo/components';
import { ArrowRight, CrossFilled } from '@teo/components/icons';
import { useTranslation } from 'react-i18next';
import 'isomorphic-fetch';
import { handleGeneration, handleAgainGeneration } from './requestAI';
import { TryAgain } from '../../ChatGPT/Icon';

const ConnectWidgetGPT = ({
  setQuestionVraag,
  setIsLoadingAI,
  isLoadingAI,
  setIsChatOpen,
  stateUid,
  questionVraag,
  state,
  connections,
  setConnections,
  rightItems,
  setRightItems,
  leftItems,
  setLeftItems,
}) => {
  const { auth } = useContext(AuthContext);
  const userId = auth?.user?.id;

  const userLang = auth?.user?.lang;

  const { t } = useTranslation();
  const inputRef = useRef(null);
  const [prompt, setPrompt] = useState('');
  const [completion, setCompletion] = useState(null);
  const [answerLeft, setAnswerLeft] = useState(3);
  const [answerRight, setAnswerRight] = useState(3);
  const [uniqueConnection, setUniqueConnection] = useState(true);
  const [prevResult, setPrevResult] = useState(null);
  const [existingObject, setExistingObject] = useState({
    score: state?.score,
    left: [],
    right: [],
    connections: [],
    vraag: questionVraag,
    type: 'Link',
  });

  const removeParagraphs = (htmlString) => {
    const withoutParagraphs = htmlString.replace(/<p[^>]*>|<\/p>/g, '');
    return withoutParagraphs;
  };

  useEffect(() => {
    const placeholder = document.querySelector(
      `#${CSS.escape(stateUid)} .wg-question .question_optional`
    );
    const handleContentChange = () => {
      const placeholderText = placeholder.innerText;
      setExistingObject((prev) => ({
        ...prev,
        vraag: placeholderText,
      }));
    };

    const observer = new MutationObserver(handleContentChange);

    observer.observe(placeholder, {
      subtree: true,
      characterData: true,
      childList: true,
    });

    return () => {
      observer.disconnect();
    };
  }, [questionVraag, stateUid]);

  useEffect(() => {
    const resultString = questionVraag ? removeParagraphs(questionVraag) : '';
    setExistingObject({
      score: state?.score,
      vraag: resultString,
      type: 'Link',
      left: leftItems,
      right: rightItems,
      connections: connections,
    });
  }, [state, questionVraag, connections, leftItems, rightItems]);

  useEffect(() => {
    if (completion) {
      // setExistingObject(completion);
      const resultString = removeParagraphs(completion?.vraag);
      setQuestionVraag(`<p>${resultString}</p>`);
      setLeftItems(completion?.left);
      setRightItems(completion?.right);
      setConnections(completion?.connections);
      setIsLoadingAI(false);
      setCompletion(null);
      setTimeout(() => {
        const placeholder = document.querySelector(
          `#${CSS.escape(stateUid)} .wg-question .question_optional`
        );
        placeholder.focus();
      }, 100);
    }
  }, [completion]);

  function handleSubmit() {
    handleGeneration(
      setIsLoadingAI,
      userLang,
      userId,
      prompt,
      setPrompt,
      setCompletion,
      existingObject,
      setPrevResult,
      answerLeft,
      answerRight,
      uniqueConnection
    );
  }

  function handleAgain() {
    handleAgainGeneration(setIsLoadingAI, userId, setCompletion, prevResult);
  }

  const handleKeyPress = (e) => {
    if (!isLoadingAI) {
      if (e.keyCode === 13 && prompt.length > 2) {
        handleSubmit();
        setPrompt('');
      }
    }
  };

  const handleChange = (e) => {
    if (!isLoadingAI) {
      setPrompt(e.target.value);
    }
  };

  const handleClose = () => {
    const placeholder = document.querySelector(`#${CSS.escape(stateUid)}`);
    const divsToRemove = placeholder.getElementsByClassName('active-widget');
    Array.from(divsToRemove).forEach((div) => {
      div.remove();
    });
    setIsChatOpen(false);
  };

  // console.log(state);
  // console.log(completion);

  const classInput =
    'px-11 h-10 w-full rounded-md border border-solid border-transparent py-0 text-base text-grey-08 !shadow-none outline outline-2 !outline-offset-0 outline-transparent !ring-0 placeholder:text-sm placeholder:text-grey-04 enabled:bg-grey-transparent-01 enabled:hover:border-grey-transparent-03 enabled:hover:bg-white enabled:hover:outline-grey-transparent-01 enabled:focus:border-secondary-04 enabled:focus:bg-white enabled:focus:outline-secondary-01 enabled:active:border-secondary-04 enabled:active:bg-white enabled:active:outline-secondary-01 disabled:border-grey-03 disabled:bg-grey-transparent-02';

  return (
    <div className="chat-action remove_me_gEE8QIPZ6LEay22SdSCU">
      <div className="relative my-3 w-full">
        <div className="relative flex w-full">
          <div className="relative mr-14 w-full">
            <img
              src="/images/icons/chatgpt.svg"
              alt="chatgpt"
              className="!absolute top-3 left-2 z-[1] w-6"
            />
            <input
              disabled={isLoadingAI}
              id="chat-gpt"
              value={prompt}
              onChange={(e) => handleChange(e)}
              placeholder={t('chat_gpt.placeholder')}
              className={classInput}
              ref={inputRef}
              onKeyUp={handleKeyPress}
            />
            <div
              className="absolute top-2.5 right-2 z-[1] cursor-pointer"
              onClick={() => handleSubmit()}
            >
              <ArrowRight
                className={` w-6 pl-2 pr-0 text-grey-05 sm:w-9 sm:w-9 sm:pr-2`}
              />
            </div>
          </div>
          <IconButton
            className="!absolute top-0.5 right-1"
            Icon={CrossFilled}
            variant="ghost"
            onClick={() => {
              handleClose();
            }}
          />
        </div>

        <p className="mt-3 text-sm text-grey-05">
          {t('chat_gpt.help_message')}
        </p>
      </div>
      <div className="flex flex-col gap-3">
        <h4>{t('widgets.multiple_choice_gpt.options')}</h4>
        <button
          disabled={prevResult && !isLoadingAI ? false : true}
          className="chat_gpt_btn flex w-max items-center gap-2 rounded-2xl bg-secondary-01 py-1 pl-3 pr-4 text-sm text-secondary-04 hover:bg-secondary-04 hover:text-secondary-01 disabled:bg-grey-02 disabled:text-grey-04"
          onClick={() => handleAgain()}
        >
          <TryAgain
            className={`w-4
              ${
                prevResult && !isLoadingAI
                  ? 'text-secondary-04'
                  : '!text-grey-04'
              }
            `}
          />
          {t('widgets.widget_chat_gpt.try_again')}
        </button>
      </div>
      <div className="mt-5 flex flex-col gap-2">
        <h4>{t('widgets.multiple_choice_gpt.answer_options')}</h4>
        <div className="mt-2 flex w-full flex-col lg:mt-0 lg:w-auto">
          <div className="flex flex-row items-center">
            <p className="mr-4 text-sm">
              {t('widgets.multiple_connect_gpt.left_options')}
            </p>
            <InputScore
              value={answerLeft}
              onChange={(value) => value > 1 && setAnswerLeft(value)}
            />
          </div>
          <div className="mt-4 flex flex-row items-center">
            <p className="mr-4 text-sm">
              {t('widgets.multiple_connect_gpt.right_options')}
            </p>
            <InputScore
              value={answerRight}
              onChange={(value) => value > 1 && setAnswerRight(value)}
            />
          </div>
          <div className="mt-4 flex flex-row items-center">
            <p className="mr-4 text-sm">
              {t('widgets.multiple_connect_gpt.unique_connection')}
            </p>
            <Switch
              checked={uniqueConnection}
              onChange={(isCheck) => setUniqueConnection(isCheck)}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ConnectWidgetGPT;
